import React, { useCallback, useEffect, useRef, useState } from "react";

import "./styles.css";

const SmartImage = ({
  src,
  alt = "",
  aspectRatio,
  width,
  height,
  fit = "cover",
  radius,
  priority = false,
  fallback,
  className = "",
  imgClassName = "",
  onClick,
  ...rest
}) => {
  const [status, setStatus] = useState(src ? "loading" : "error");
  const nodeRef = useRef(null);

  useEffect(() => {
    setStatus(src ? "loading" : "error");
  }, [src]);

  const attach = useCallback((node) => {
    nodeRef.current = node;

    if (node?.complete && node.naturalWidth > 0) setStatus("ready");
  }, []);

  const showPlaceholder = status !== "ready";

  return (
    <span
      className={`sy-img ${className}`}
      style={{
        ...(aspectRatio ? { aspectRatio } : null),
        ...(width ? { width } : null),
        ...(height ? { height } : null),
        ...(radius ? { borderRadius: radius } : null),
      }}
      onClick={onClick}
    >
      {showPlaceholder && (
        <span className="sy-img-placeholder" aria-hidden="true">
          {status === "error" && (fallback || <span className="sy-img-glyph" />)}
        </span>
      )}

      {src && status !== "error" && (
        <img
          ref={attach}
          src={src}
          alt={alt}
          loading={priority ? "eager" : "lazy"}
          decoding={priority ? "sync" : "async"}
          fetchpriority={priority ? "high" : undefined}
          draggable="false"
          className={`sy-img-el ${status === "ready" ? "is-ready" : ""} ${imgClassName}`}
          style={{ objectFit: fit }}
          onLoad={() => setStatus("ready")}
          onError={() => setStatus("error")}
          {...rest}
        />
      )}
    </span>
  );
};

export default React.memo(SmartImage);
